<template lang="html">
  <div class="page-wrapper trans-wrapper">
    <div class="container">
      <div class="content">
        <div class="row">
          <div class="col-md-12">
            <div class="container search-content">
              <h2>Payment History of {{ userName }}</h2>
              <div class="upgrade-button">
                <BaseButton type="primary" @click="handleUpgradeButtonClick"
                  >Upgrade Payment
                </BaseButton>
              </div>
            </div>
          </div>
        </div>
        <BaseTable
          class="trans-table-wrapper"
          :columns="columns"
          :data="paymentHistories"
          :loading="paymentHistoriesLoading"
        />
      </div>
    </div>
    <a-drawer
      class="update-drawer"
      :title="`Upgrade Payment`"
      :width="520"
      :visible="showUpgradeDrawer"
      :key="showUpgradeDrawer"
      :body-style="{ padding: '20px' }"
      @close="() => this.handleUpgradeButtonClick()"
    >
      <ClubPayment
        v-if="onlyClubCoach()"
        :id="upgradeKey"
        @close-drawer="handleUpgradeButtonClick(true)"
      />
      <PaymentShow
        v-else
        :id="upgradeKey"
        @close-drawer="handleUpgradeButtonClick(true)"
      />
    </a-drawer>
  </div>
</template>

<script>
import { Payment } from "@/models";
import { mapGetters } from "vuex";
import { PAYMENT_HISTORY_COLUMNS } from "@/utils/columns";
const PAYMENT_STORE_KEY = "paymentStore";
import PaymentShow from "./payment-upgrade";
import ClubPayment from "./club-payment";

export default {
  data() {
    return {
      showUpgradeDrawer: false
    };
  },
  async created() {
    await this.$store.dispatch(`${PAYMENT_STORE_KEY}/clearPaymentHistory`);
    await this.dispatcher();
  },
  components: {
    PaymentShow,
    ClubPayment
  },
  computed: {
    upgradeKey() {
      return this.$route.params.profileId;
    },
    userName() {
      return this.$route.query.name || JSON.parse(localStorage["user-name"]);
    },
    columns() {
      return PAYMENT_HISTORY_COLUMNS;
    },
    ...mapGetters({
      paymentHistories: `${PAYMENT_STORE_KEY}/paymentHistories`,
      paymentHistoriesLoading: `${PAYMENT_STORE_KEY}/paymentHistoryLoading`
    })
  },
  methods: {
    handleUpgradeButtonClick(dispatch = false) {
      this.showUpgradeDrawer = !this.showUpgradeDrawer;
      if (dispatch) this.dispatcher();
    },
    async dispatcher() {
      await this.$store.dispatch(`${PAYMENT_STORE_KEY}/paymentHistories`, {
        profileId: this.upgradeKey
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.trans-table-wrapper {
  /deep/ {
    .ant-table-row {
      td:nth-child(3) {
        font-weight: bold;
        color: #000;
      }
    }
  }
}
.upgrade-button {
  margin-bottom: 30px;
}
</style>
